import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonWorkerPoolOverview } from "../../CommonComponents/CommonWorkerPoolViews";
export const InfrastructureWorkerPoolRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.workerPool,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonWorkerPoolOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
